module.exports = __webpack_public_path__ + "img/metrics-icon-dark.49ba8f7f.svg";